import { useEffect, useState } from 'react';
import apiServices from '../../services/service';
import LeftOptions from './leftOptions';
import RightContentUiPermissions from './rightContentUiPermissions';
import Loader from '../../shared/component/Loader';
import { toast } from 'react-toastify';

const UiPermissions = ({
  options,
  uiPermissionsModuleName,
  showoptionsUiPermissions,
  handleSelectOptionUiPermissions,
  activeOptionUiPermissions,
  checkbox,
  permissionForParticularRoleInSaveFormat,
  handleCheckboxChange,
}) => {
  const [loading, setLoading] = useState(false);
  const [checkboxes, setCheckboxes] = useState(checkbox);

  useEffect(() => {
    setCheckboxes(checkbox);
  }, [checkbox]);

  const handleSaveUiPermissions = () => {
    // Uncomment below if you want to proceed with API call
    if (permissionForParticularRoleInSaveFormat) {
      setLoading(true);
      // Call the API service method
      apiServices
        .saveUiPermissionsByRole(permissionForParticularRoleInSaveFormat)
        .then((response) => {
          let tmpData = response.data;
          if (response.status === 200) {
            setLoading(false);
            toast.success('UI Permissions updated successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          toast.error(`${error.message}`, { position: 'top-right' });
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="whitediv">
        <LeftOptions
          options={uiPermissionsModuleName}
          onSelectOption={handleSelectOptionUiPermissions}
          activeOption={activeOptionUiPermissions}
          uiPermissions={uiPermissionsModuleName}
        />
        <div className="UIcontentBlock">
          {checkboxes && showoptionsUiPermissions !== undefined ? (
            <RightContentUiPermissions
              selectedOption={showoptionsUiPermissions}
              handleCheckboxChange={handleCheckboxChange}
              checkboxes={checkboxes}
            />
          ) : (
            checkboxes && (
              <RightContentUiPermissions
                selectedOption={options[0]}
                handleCheckboxChange={handleCheckboxChange}
              />
            )
          )}
          <div className="saveBtnPos">
            <button
              className="save-btn"
              variant="contained"
              color="primary"
              onClick={handleSaveUiPermissions}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UiPermissions;
